import type React from 'react';
import { EvaluationMark } from '../../../-components/EvaluationMark';
import { EvaluationPassRate } from '../../../-components/EvaluationPassRate';
import styles from './index.module.scss';

const PASS_RATE_PERCENTAGE = 100;
const EVALUATION_ITEMS = [
  {
    id: '1',
    title: 'AIと会話できたか',
    description:
      'AIとの基本的な対話操作が確認できました。本番のロールプレイでも、この調子でAIとの対話を進めていきましょう。',
    isPassed: true,
  },
  {
    id: '2',
    title: '自分の目標をしっかり言葉にできたか',
    description:
      'ご自身の考えを言葉にしてAIに伝えることができました。具体的で素晴らしい目標設定です。',
    isPassed: true,
  },
  {
    id: '3',
    title: '対話から考えを深めることができたか',
    description:
      'AIからの問いかけに対し、ご自身の経験を元に回答することで、目標がより明確になりました。この対話の感覚を本番でも活かしていきましょう。',
    isPassed: true,
  },
];

export type EvaluationSummaryProps = {
  isEvaluated: boolean;
};

export const EvaluationSummary: React.FC<EvaluationSummaryProps> = ({
  isEvaluated,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.titleArea}>
          <span className={styles.subLabel}>評価項目ごとの達成率</span>
          <h3 className={styles.title}>目標設定ロールプレイ</h3>
        </div>
        <div className={styles.scoreHeader}>
          <EvaluationPassRate
            score={isEvaluated ? PASS_RATE_PERCENTAGE : null}
            isActive={true}
          />
        </div>
      </div>

      <div className={styles.itemsContainer}>
        {EVALUATION_ITEMS.map((item) => (
          <div key={item.id} className={styles.item}>
            <div className={styles.itemContent}>
              <h4 className={styles.itemTitle}>{item.title}</h4>
              <p className={styles.itemDescription}>{item.description}</p>
            </div>
            <div className={styles.itemEvaluations}>
              <div className={styles.evaluationCell}>
                <EvaluationMark
                  isPassed={isEvaluated ? item.isPassed : null}
                  className={styles.icon}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
